export default __webpack_public_path__ + "static/texture-white-8f52d8a8c69bc66ea77ae1e2b6e5de7e.svg";